import { types } from 'actions/organisation';
import { searchSuperOrganisationResearchers } from 'services/api';
import { searchId as id } from 'components/common';

// Tradeshows tab. Pure mechanical extraction — no behaviour change.

export const tradeshowsReducers = {
  [types.SET_TRADESHOWS_SEARCH_REQUEST]: (state, action) => {
    const { organisationId, searchRequest } = action.payload;
    if (searchRequest.res) {
      return {
        ...state,
        tradeshowTotals: {
          ...state.tradeshowTotals,
          [organisationId]: {
            people: searchRequest.res.distinctSuperResearchersCount,
            countries: searchRequest.res.countryCount,
            emailCount: searchRequest.res.emailCount,
            activities:
              searchRequest.res.totalFunding +
              searchRequest.res.totalPosters +
              searchRequest.res.totalPublications +
              searchRequest.res.totalClinicalTrials,
          },
        },
        organisationExhibitors: {
          ...state.organisationExhibitors,
          [organisationId]: searchRequest.res,
        },
        loadingExhibitorData: {
          ...state.loadingExhibitorData,
          [organisationId]: false,
        },
      };
    }
    return {
      ...state,
      loadingExhibitorData: {
        ...state.loadingExhibitorData,
        [organisationId]: searchRequest.loading ?? false,
      },
    };
  },

  [types.PERFORM_TRADESHOWS_SEARCH]: (state, action) => {
    const { organisationId, request } = action.payload;

    const initialOrder = 'LastActivityDate';
    const initialOrderBy = 'desc';

    const order = state.sort[organisationId]
      ? state.sort[organisationId].field
      : initialOrder;

    const orderBy = state.sort[organisationId]
      ? state.sort[organisationId].direction
      : initialOrderBy;

    request({
      url: searchSuperOrganisationResearchers(organisationId),
      body: {
        id,
        query: `(*)`,
        count: 1,
        order,
        orderBy,
        isTradeshowsSearch: true,
      },
    });

    return {
      ...state,
    };
  },
};
